import React from 'react';
import FormikRadioButtons from 'src/components/formik-radio-buttons';

/**
 *
 * @requires formik.values.highSchoolInfo
 */
const LunchPlanInput = () => (
  <FormikRadioButtons
    name="highSchoolInfo.lunchPlan"
    options={[
      {value: 'FRL', label: 'Yes'},
      {value: 'None', label: 'No'},
      {value: "Don't Know", label: 'Not sure'},
    ]}
    legendText="Are you eligible to receive free or reduced-price lunch at school?"
  />
);

export default LunchPlanInput;
